import { ReactNode } from "react";
import Select, { components } from "react-select";
import "./Dropdown.scss";

interface IDropdownOption {
  value: string;
  label: string;
  icon?: ReactNode;
}

interface DropdownProps {
  options?: IDropdownOption[];
  groupedOptions?: { label: string; options: IDropdownOption[] }[];
  title: string;
  onSelect: (value: string) => void;
  value: string;
  isLoading?: boolean;
  width?: number | string;
  borderRadius?: string;
  isSearchable?: boolean;
  short?: boolean;
  fixedMenu?: boolean;
  classes?: string;
  bordered?: boolean;
  height?: number;
}

function Dropdown(props: DropdownProps) {
  const CustomDropdownIndicator = (props: any) => (
    <components.DropdownIndicator {...props}>
      <i className="fa-solid fa-caret-down" />
    </components.DropdownIndicator>
  );

  let value: IDropdownOption | undefined | null;
  if (props.options) {
    value = props.options.find((option) => option.value === props.value);
  }
  if (props.groupedOptions) {
    const allOptions: IDropdownOption[] = [];
    for (let i = 0; i < props.groupedOptions.length; i++) {
      const optionArray = props.groupedOptions[i];
      allOptions.push(...optionArray.options);
    }
    value = allOptions.find((option) => option.value === props.value);
  }
  if (props.value === "") {
    value = null;
  }

  return (
    <Select
      // menuIsOpen={true}
      options={props.options || props.groupedOptions}
      value={value}
      className={props.classes || "dropdown"}
      classNamePrefix="rs"
      placeholder={props.title}
      loadingMessage={() => "Laddar..."}
      isLoading={props.isLoading}
      onChange={(option: any) => {
        props.onSelect(option?.value || "");
      }}
      formatOptionLabel={(option: any) =>
        option?.icon ? (
          <span
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            {option.icon}
            <span>{option.label}</span>
          </span>
        ) : (
          option?.label
        )
      }
      noOptionsMessage={() => "Inga resultat"}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: CustomDropdownIndicator,
      }}
      isSearchable={
        props.isSearchable === undefined ? false : props.isSearchable
      }
      menuPosition={props.fixedMenu ? "fixed" : "absolute"}
      styles={{
        container: (base) => ({
          ...base,
          width: props.width || 125,
        }),
        control: (base) => ({
          ...base,
          width: "100%",
          color: "var(--primary-text)",
          borderRadius: props.borderRadius || "40px",
          border: props.bordered
            ? "var(--primary-border)"
            : "0px solid #A6A6AF",
          "&:hover": {
            border: props.bordered
              ? "var(--primary-border)"
              : "0px solid #A6A6AF",
          },
          minHeight: props.height
            ? `${props.height}px`
            : props.short
              ? "30px"
              : "38px",
          height: props.height ? `${props.height}px` : base.height,
          maxHeight: props.height ? `${props.height}px` : base.maxHeight,
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
          boxShadow: "none",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isFocused ? "transparent" : "transparent",
          color: state.isFocused ? "#007aff" : "var(--primary-text)",
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
          ":active": {
            color: "#007aff",
          },
        }),
        menu: (base) => ({ ...base, zIndex: 100000 }),
        dropdownIndicator: (base, state) => ({
          ...base,
          transition: "all 200ms ease",
          transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "",
          color: "#000D33",
          "&:hover": {
            color: "#000D33",
          },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: props.short ? "0 8px" : "0px 8px",
          flexWrap: "nowrap",
        }),
        placeholder: (base) => ({
          ...base,
          whiteSpace: "nowrap",
          color: "var(--primary-text)",
          fontWeight: 500,
        }),
        singleValue: (base) => ({
          ...base,
          whiteSpace: "nowrap",
          color: "var(--primary-text)",
          fontWeight: 500,
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          color: "var(--primary-text)",
        }),
      }}
    />
  );
}

export default Dropdown;
